import { get, set } from 'lodash';

import { ASSET_TYPE, FIELD_PATHS, FREQUENCY, PROPERTY_EXPENSE_TYPE, PROPERTY_EXPENSES } from '@funnels/constants';
import { Asset, FormValuesIncomesExpenses, PropertyExpenses } from '@funnels/types';

export const initialisePropertyExpenses = (data: FormValuesIncomesExpenses, forceInitialise?: boolean) => {
  const assets: Asset[] = get(data, FIELD_PATHS.ASSETS(), []).map((asset: Asset) => {
    const isPropertyAsset = get({ assets: [asset] }, FIELD_PATHS.ASSET_TYPE(0)) === ASSET_TYPE.PROPERTY;
    const propertyExpenses: PropertyExpenses[] = get({ assets: [asset] }, FIELD_PATHS.ASSET_PROPERTY_EXPENSES(0), []);

    // Inistialise property expenses if they are not set
    if ((isPropertyAsset && !propertyExpenses.length) || (isPropertyAsset && forceInitialise)) {
      const newExpenses: PropertyExpenses[] = PROPERTY_EXPENSES.map((expenseType: PROPERTY_EXPENSE_TYPE) => {
        return {
          type: expenseType,
          frequency: FREQUENCY.MONTHLY,
        };
      });

      set({ assets: [asset] }, FIELD_PATHS.ASSET_PROPERTY_EXPENSES(0), newExpenses);
    }
    // If property expenses always add new fields
    else if (isPropertyAsset) {
      const newExpenses: PropertyExpenses[] = PROPERTY_EXPENSES.map((expenseType: PROPERTY_EXPENSE_TYPE) => {
        const existing = propertyExpenses.find((expense) => expense.type === expenseType);
        return {
          type: expenseType,
          frequency: FREQUENCY.MONTHLY,
          ...existing,
        };
      });

      set({ assets: [asset] }, FIELD_PATHS.ASSET_PROPERTY_EXPENSES(0), newExpenses);
    }

    return asset;
  });
  set(data, FIELD_PATHS.ASSETS(), assets);
};

export const clearPropertyAssetExpenses = (data: FormValuesIncomesExpenses) => {
  const assets: Asset[] = get(data, FIELD_PATHS.ASSETS(), []).map((asset: Asset) => {
    const isPropertyAsset = get({ assets: [asset] }, FIELD_PATHS.ASSET_TYPE(0)) === ASSET_TYPE.PROPERTY;
    if (isPropertyAsset) {
      set({ assets: [asset] }, FIELD_PATHS.ASSET_PROPERTY_EXPENSES(0), undefined);
    }
    return asset;
  });
  set(data, FIELD_PATHS.ASSETS(), assets);
};
